import React, { lazy, Suspense, useEffect, useState } from 'react';

import { PageLevel } from '@/components/PageContainer';
import PageHeader from '@/components/PageContainer/PageHeader';
import Spin from '@/components/Spin';
import { useFingerPrint } from '@/hooks/useFingerPrint';
import { useI18nContext } from '@/i18n/I18n';
import { useStore } from '@/store/useStore';

import LazyEntry from './lazyEntry';
// const LazyEntry = lazy(() => {
//   return import('./lazyEntry');
// });

const App = () => {
  const [$t] = useI18nContext();
  const { userInfo } = useStore();
  const { fingerReport } = useFingerPrint();

  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (userInfo?.id) {
      fingerReport('wf01', '1');
    }
  }, [userInfo]);

  return (
    <>
      <PageHeader pageLevel={PageLevel.main} pageTitle={$t('security')} />
      {/* {(!userInfo?.id || !loaded) && <SecuritySkeleton />} */}
      <LazyEntry loadFn={() => setLoaded(true)} />
      {!userInfo.id && (
        <div
          style={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100vh',
          }}
        >
          <Spin spinning={!userInfo?.id}>
            <div style={{ height: '100vh' }}></div>
          </Spin>
        </div>
      )}
    </>
  );
};

export default App;
